let tasks = []
let isListening = false
/*
 Enqueue tasks...
 */
export const idleEnqueue = (funcs) => {
  if (Array.isArray(funcs)) {
    tasks = [...funcs, ...tasks]
  } else if (typeof funcs === 'function') {
    tasks.push(funcs)
  } else {
    console.warn(`${typeof funcs} is not a supported type`)
    return false
  }

  if (!isListening) {
    addListeners()
  }
  idleUntilUrgent()
}

const addListeners = () => {
  if (typeof window !== 'undefined' && !isListening) {
    const isSafari = !!(typeof safari === 'object' && safari.pushNotification) // eslint-disable-line
    window.addEventListener('visibilitychange', runUrgentTasksImmediately, true)

    // Safari does not reliably fire the `pagehide` or `visibilitychange`
    // events when closing a tab, so we have to use `beforeunload` with a
    // timeout to check whether the default action was prevented.
    // - https://bugs.webkit.org/show_bug.cgi?id=151610
    // - https://bugs.webkit.org/show_bug.cgi?id=151234
    // NOTE: we only add this to Safari because adding it to Firefox would
    // prevent the page from being eligible for bfcache.
    if (isSafari) {
      window.addEventListener('beforeunload', runUrgentTasksImmediately, true)
    }

    isListening = true
  }
}

const removeListeners = () => {
  if (typeof window !== 'undefined' && !isListening) {
    const isSafari = !!(typeof safari === 'object' && safari.pushNotification) // eslint-disable-line
    window.removeEventListener('visibilitychange', runUrgentTasksImmediately, true)

    if (isSafari) {
      window.removeEventListener('beforeunload', runUrgentTasksImmediately, true)
    }
    isListening = false
  }
}

const idleDequeue = () => {
  if (!tasks.length) {
    removeListeners()
    return false
  }

  return tasks.shift()
}

const idleCallback = () => {
  const func = idleDequeue()
  if (func) {
    func()
    idleUntilUrgent()
  }
  return false
}

const runUrgentTasksImmediately = () => {
  while (tasks.length) {
    const task = tasks.shift()
    task()
  }
}

export const idleUntilUrgent = () => {
  if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
    window.requestIdleCallback(idleCallback, { timeout: 2000 })
  } else if (typeof window !== 'undefined') {
    (function (callback = idleCallback) {
      if (callback) {
        return setTimeout(function () {
          callback()
        }, 1)
      }
    })()
  }
}
